import Cookie from 'js-cookie';
import { isLocalDev } from '@mgo/core/src/environment';

export const setSession = (uuid, orderId) => {
  Cookie.set('coa', uuid, {
    expires: 0.5 / 24, // expire 30 minutes
    sameSite: 'strict',
    secure: !isLocalDev(window.location.origin),
  });
  if (orderId) {
    Cookie.set('coaOrderId', orderId, {
      expires: 0.5 / 24, // expire 30 minutes
      sameSite: 'strict',
      secure: !isLocalDev(window.location.origin),
    });
  }
};
export const getOrderIdSession = () => {
  Cookie.get('coaOrderId');
};
export const getSession = () => {
  Cookie.get('coa');
};

export const deleteSession = () => {
  Cookie.remove('coa');
  Cookie.remove('coaOrderId');
};

export const deleteCoaComplete = () => {
  Cookie.remove('coa_complete');
};

export const resetAppState = () => {
  // delete prefil and informed delivery session variables
  [
    'myMovePrefillOptIn', 'myMoveChoicePrefillOptIn',
    'informedDeliveryEligible', 'informedDelivery',
    'extension', 'extensionSelected',
    'offersChoice', 'autofillChoice', 'amp_data',
  ].forEach((v) => {
    sessionStorage.removeItem(v);
  });
};
